module.exports = __webpack_public_path__ + "img/sword-fire-02.12ef8809.png";